var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "managed-agile-teams") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.4765625%",
    y1: "91.8652344%",
    x2: "23.3007812%",
    y2: "9.76367188%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6B684",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFCB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-23.5%",
    y: "-40.0%",
    width: "147.1%",
    height: "180.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.964705882   0 0 0 0 0.71372549   0 0 0 0 0.517647059  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-185.000000, -2504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(150.000000, 2445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(35.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "managed-agile-teams",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-2)",
    transform: "translate(8.000000, 15.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L31,0 C31.5522847,-1.01453063e-16 32,0.44771525 32,1 L32,19 C32,19.5522847 31.5522847,20 31,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,1 C2,0.44771525 2.44771525,-1.20591542e-16 3,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,17 L33,17 C33.5522847,17 34,17.4477153 34,18 L34,19 C34,19.5522847 33.5522847,20 33,20 L1,20 C0.44771525,20 2.8967998e-16,19.5522847 0,19 L0,18 C-6.76353751e-17,17.4477153 0.44771525,17 1,17 Z",
    id: "Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: "two-men",
    transform: "translate(18.000000, 20.000000)",
    fill: "#F78761",
    fillRule: "nonzero",
    opacity: 0.695033482
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2272727,3.85714286 C11.3863636,3.85714286 12.2727273,3.02142857 12.2727273,1.92857143 C12.2727273,0.835714286 11.3863636,0 10.2272727,0 C9.06818182,0 8.18181818,0.835714286 8.18181818,1.92857143 C8.18181818,3.02142857 9.06818182,3.85714286 10.2272727,3.85714286 Z M4.77272727,3.85714286 C5.93181818,3.85714286 6.81818182,3.02142857 6.81818182,1.92857143 C6.81818182,0.835714286 5.93181818,0 4.77272727,0 C3.61363636,0 2.72727273,0.835714286 2.72727273,1.92857143 C2.72727273,3.02142857 3.61363636,3.85714286 4.77272727,3.85714286 Z M4.77272727,5.14285714 C3.20454545,5.14285714 0,5.91428571 0,7.39285714 L0,9 L9.54545455,9 L9.54545455,7.39285714 C9.54545455,5.91428571 6.34090909,5.14285714 4.77272727,5.14285714 Z M10.2272727,5.14285714 C10.0227273,5.14285714 9.81818182,5.14285714 9.54545455,5.20714286 C10.3636364,5.72142857 10.9090909,6.49285714 10.9090909,7.39285714 L10.9090909,9 L15,9 L15,7.39285714 C15,5.91428571 11.7954545,5.14285714 10.2272727,5.14285714 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon1);
export default __webpack_public_path__ + "static/media/stack-icon-1.8e5fc1e47abd1225763586b85d6c9154.svg";
export { ForwardRef as ReactComponent };